/* eslint-disable @typescript-eslint/no-empty-function */
import * as React from 'react';

import { notification, Row, Tooltip, Divider, Menu } from 'antd';
import {
  Avatar,
  Avatar as AvatarCore,
  CaretDownOutlined,
  Dropdown,
  Notification,
  Space,
  Text,
  Row as CRow,
  Padding,
  UserOutlined,
  Column,
  Button,
  ButtonType,
} from 'farmhub-ui-core';
import { useHistory, useLocation } from 'react-router';

import { useAppDispatch, useAppSelector } from 'app';
import { IconNotification, InfoCard } from 'components';
import Apps from 'components/Apps';
import { LeftArrowOutlineIcon, NewTabOutlineIcon } from 'components/Icon';
import {
  BellOutlineIcon,
  InviteOutlineIcon,
  SettingOutlineIcon,
} from 'components/Icon/Menu';
import AccountModal from 'containers/App/Account/AccountModal';
import { env } from 'env';
import {
  addNotiItem,
  decreaseCount,
  findColor,
  findEntityPricePolicyForSelect,
  findEntityProposalPolicyForSelect,
  findRooms,
  getNotificationCount,
  saveRoute,
  selectColor,
  selectQuickStart,
  updateNotificationStatus,
  updateRoom,
} from 'slice';
import { theme } from 'styled';
import {
  IMAGETYPE,
  activityType,
  detechTime,
  formatImageUrl,
  handleRedirect as handleOpenNewTab,
  getLastWord,
  getDirectLink,
  checkPermission,
  isCheckDomain,
} from 'utils';

import {
  DivRow,
  DivWrapper,
  MenuItem,
  Wrapper,
  WrapperNotification,
  WrapperShortcut,
  AvatarStyles,
} from './styles';

interface HeaderMainNavbarProps {
  user: any;
  title: string;
  hideMenu: boolean;
  breadcrumb?: React.ReactNode;
  syncStatus?: React.ReactNode;
  onLogoutUser: (e: any) => void;
}

const HeaderMainNavbar = ({
  user,
  hideMenu = false,
  title = '',
  breadcrumb,
  syncStatus,
  onLogoutUser,
}: HeaderMainNavbarProps): JSX.Element => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const isToggle = useAppSelector(state => state.account.isToggle);
  const isCheckUI = isCheckDomain();
  const [mounted, setMounted] = React.useState(false);
  const [width, setWidth] = React.useState(1200);
  const notiCount = useAppSelector(state => state.notification.count);
  const accountID = useAppSelector(state => state.account.item?.id);
  const accessToken = useAppSelector(state => state.auth.accessToken);
  const permissions = useAppSelector(state => state.account.permissions);
  const ws = React.useRef<any>(null);
  const wsNotification = React.useRef<any>(null);
  const quickStart = useAppSelector(selectQuickStart);
  const color = useAppSelector(selectColor);

  const handleUpdateStatus = async (
    id: string,
    selectedActivityType: number
  ) => {
    const param = {
      id,
      body: {
        status: 2,
      },
      activityType: selectedActivityType,
    };
    try {
      await dispatch(updateNotificationStatus(param)).unwrap();
    } catch (error: any) {
      Notification('error', 'Đổi trạng thái thất bại', error);
    }
  };

  const pushNotify = (data: any) => {
    notification.open({
      message: 'Thông báo mới',
      description: (
        <InfoCard
          img={
            <AvatarCore
              size={64}
              src={formatImageUrl(data.src.avatar, IMAGETYPE.AVATAR.xxs)}
              styles={{ 'flex-shrink': 0 }}
            />
          }
          info={
            <Text size="xxs" styles={{ 'margin-top': '3px' }}>
              {detechTime(data.atTime)}
            </Text>
          }
          name={
            <DivWrapper>
              <Text
                color="main"
                styles={{ 'margin-right': '3px' }}
                weight="bold"
              >
                {data.src?.name}
              </Text>{' '}
              <Text>{activityType(data.activityType)}</Text>{' '}
              <Text
                color="main"
                styles={{ 'margin-right': '3px' }}
                weight="bold"
              >
                {data.dst?.name}
              </Text>
            </DivWrapper>
          }
          width={364}
        />
      ),
      style: {
        cursor: 'pointer',
      },
      placement: 'bottomLeft',
      onClick: () => {
        handleUpdateStatus(data.id, data.activityType);
        dispatch(decreaseCount());
        handleRedirect(data);
      },
    });
  };

  const handleRedirect = noti => {
    switch (noti.activityType) {
      case 30:
      case 31:
      case 32:
      case 33:
      case 34: // Đơn nhập hàng
        return history.push(`/order/${noti.dst.id}/detail`);
      case 0: // Đơn hàng bán
        return history.push(`/order/${noti.dst.id}/detail`);
      case 20: // Thực hiện chiến dịch
        return history.push(`/marketing/campaign/${noti.dst.id}/detail`);
      case 10: // Gửi lời mời liên kết
        return history.push(`/partner/request`);
      case 11: // Chấp nhận lời mời liên kết
        return history.push(`/partner/linked`);
      case 40:
      case 41:
      case 42: // Tương tác sản phẩm
        return history.push(`/product/${noti.dst.id}/detail`);
      case 43: // Đánh giá đối tượng nuôi trồng
        return history.push(`/farming-plant/${noti.dst.id}/detail`);
      case 44: // Mời tham gia mua chung
        return history.push(`co-buy/${noti.dst.id}/detail`);
      case 45: // Mời tham gia chiến dịch
        return history.push(`/marketing/campaign/${noti.dst.id}/detail`);
      default:
        return 0;
    }
  };

  const initNotificationWebSocket = (userId: string, token: string) => {
    wsNotification.current = new WebSocket(
      `${env.service.notificationWSService}/${token}`
    );

    wsNotification.current.onopen = () => {
      const userInfo = {
        entityID: userId,
      };
      wsNotification.current.send(JSON.stringify(userInfo));
    };

    wsNotification.current.onclose = () => {
      setTimeout(() => initNotificationWebSocket(userId, token), 1000);
    };

    wsNotification.current.onmessage = (message: any) => {
      try {
        const data = JSON.parse(message?.data);
        if (data?.entityID === accountID) {
          pushNotify(data);
          dispatch(addNotiItem(data));
        }
      } catch (error) {
        console.log(error);
      }
    };

    return wsNotification;
  };

  const initWebSocket = (entityID: string, token: string) => {
    console.log('init web socket');
    ws.current = new WebSocket(
      `${env.service.chatWSService}/${entityID}/${token}`
    );
    ws.current.onopen = () => {
      console.log('ws opened');
    };
    ws.current.onclose = () => {
      console.log('ws closed');
    };
  };

  const dropdownItems = React.useMemo(
    () => [
      <>
        <Padding padding="0px 18px 18px 12px">
          <CRow styles={{ gap: 8 }} width="fit-content">
            <Avatar
              size={42}
              {...(user?.avatar
                ? { src: formatImageUrl(user?.avatar) }
                : { icon: { children: <UserOutlined /> } })}
              styles={AvatarStyles}
            />
            <Column styles={{ gap: 2 }}>
              <Text
                color="primary"
                size="xs"
                styles={{ fontSize: '13px !important' }}
                textTransform="capitalize"
                weight="extraBold"
              >
                {user?.fullName || 'Trống'}
              </Text>
              <Text
                color="secondary"
                size="xxs"
                styles={{ fontStyle: user?.email ? 'normal' : 'italic' }}
              >
                {user?.email || 'Chưa có email'}
              </Text>
            </Column>
          </CRow>
        </Padding>
        <Menu.Divider style={{ margin: 0 }} />
      </>,
      <MenuItem
        key="/account/information"
        active={false}
        disabled={false}
        onClick={() => history.push('/account/information')}
      >
        <Text
          className="textMenu"
          styles={{ 'margin-left': '0px' }}
          weight="bold"
        >
          Thông tin của tôi
        </Text>
      </MenuItem>,
      <MenuItem
        key="/account/information"
        active={false}
        disabled={false}
        onClick={() => history.push('/account/change-password')}
      >
        <Text
          className="textMenu"
          styles={{ 'margin-left': '0px' }}
          weight="bold"
        >
          Đổi mật khẩu
        </Text>
      </MenuItem>,
      <MenuItem
        key="/account/information"
        active={false}
        disabled={false}
        onClick={onLogoutUser}
      >
        <Text
          className="textMenu"
          styles={{ 'margin-left': '0px' }}
          weight="bold"
        >
          Đăng xuất
        </Text>
      </MenuItem>,
    ],
    [quickStart.visibleQuickStart]
  );

  React.useEffect(() => {
    if (accountID && !ws.current) {
      const wsNoti = initNotificationWebSocket(accountID, accessToken);
      wsNoti.current.close();
    }
  }, [accessToken, accountID]);

  React.useEffect(() => {
    if (accountID && !ws.current) {
      initWebSocket(accountID, accessToken);
      const findChatRooms = async () => {
        try {
          await dispatch(findRooms({ entityID: accountID })).unwrap();
        } catch (error) {
          console.log('An error occurred while finding rooms', error);
        }
      };
      findChatRooms();
    }
  }, [accessToken, accountID, dispatch]);

  React.useEffect(
    () => () => {
      if (ws.current) {
        ws.current.close();
      }
    },
    []
  );

  React.useEffect(() => {
    if (!ws.current) return;

    ws.current.onmessage = async (message: any) => {
      const data = JSON.parse(message?.data);
      if (data.senderID !== accountID) {
        dispatch(updateRoom({ data }));
      }
    };
  }, [accountID, dispatch]);

  React.useEffect(() => {
    const initCountNotification = async () => {
      try {
        await dispatch(
          getNotificationCount({
            entityID: accountID,
          })
        ).unwrap();
      } catch (error: any) {
        console.log(
          'An error occurred while finding notification item count',
          error
        );
      }
    };

    initCountNotification();
  }, [accountID, dispatch]);

  const handleWindowResize = () => {
    setWidth(window.innerWidth);
  };

  React.useLayoutEffect(() => {
    setMounted(true);
    handleWindowResize();
  }, []);

  React.useLayoutEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  React.useEffect(() => {
    const initData = async () => {
      try {
        await dispatch(
          findColor({
            page: 1,
            take: 100,
            select: ['id', 'name', 'code'],
          })
        ).unwrap();
      } catch (error: any) {
        Notification('error', 'Tải mã màu thất bại', error);
      }
    };

    if (color.list?.length == 0) {
      initData();
    }
  }, [dispatch]);

  React.useEffect(() => {
    const initPricePolicy = async () => {
      try {
        await dispatch(
          findEntityPricePolicyForSelect({
            entityID: accountID,
          })
        ).unwrap();
      } catch (error: any) {
        if (![422, 403].includes(error?.statusCode ?? error?.code)) {
          Notification('error', 'Tải dữ liệu thất bại', error);
        }
      }
    };

    if (accountID) {
      initPricePolicy();
    }
  }, [dispatch, accountID]);

  React.useEffect(() => {
    const initProposalPolicy = async () => {
      try {
        await dispatch(
          findEntityProposalPolicyForSelect({
            entityID: accountID,
          })
        ).unwrap();
      } catch (error: any) {
        if (![422, 403].includes(error?.statusCode ?? error?.code)) {
          Notification('error', 'Tải dữ liệu thất bại', error);
        }
      }
    };

    if (accountID) {
      initProposalPolicy();
    }
  }, [dispatch, accountID]);

  if (!mounted) {
    return <></>;
  }

  return (
    <Wrapper id="header" style={{ height: hideMenu ? '57px' : '' }}>
      <DivRow>
        {hideMenu ? (
          <CRow width="fit-content">
            <Button
              height={theme.button.height.sm}
              icon={{
                children: <LeftArrowOutlineIcon height={18} width={18} />,
              }}
              type={ButtonType.Text}
              onClick={() => {
                dispatch(saveRoute(location.pathname));
                history.goBack();
              }}
            >
              Quay lại
            </Button>
            <Divider type="vertical" />
            <Button
              height={theme.button.height.sm}
              icon={{
                children: <NewTabOutlineIcon height={18} width={18} />,
              }}
              type={ButtonType.Text}
              onClick={() => handleOpenNewTab(`/admin`)}
            >
              Mở Tab mới
            </Button>
            <Divider type="vertical" />
            <CRow
              alignItems="center"
              styles={{ gap: 4, marginLeft: 12 }}
              width="fit-content"
            >
              {syncStatus ? (
                <>
                  {syncStatus}
                  <Space width={6} />
                </>
              ) : null}

              <Text
                color="dark"
                lineHeight="auto"
                styles={{ flexShrink: 0 }}
                textTransform="uppercase"
                weight="extraBold"
              >
                Khu vực:
              </Text>
              <Text
                color="main"
                lineHeight="auto"
                styles={{ flexShrink: 0 }}
                textTransform="uppercase"
                weight="extraBold"
              >
                {title}
              </Text>
            </CRow>
          </CRow>
        ) : (
          breadcrumb
        )}
      </DivRow>
      <DivRow style={{ gap: 12, flexShrink: 0 }}>
        {hideMenu ? (
          <>
            <Row style={{ minWidth: '200px', maxWidth: '260px' }}>
              <AccountModal
                directLink={getDirectLink(location.pathname)}
                isToggle={isToggle}
              />
            </Row>
          </>
        ) : (
          <DivRow style={{ gap: 8 }}>
            {checkPermission({
              permissions,
              module: 'setting',
            }) && (
              <Tooltip placement="bottom" title="Cấu hình">
                <WrapperShortcut onClick={() => history.push(`/settings`)}>
                  <WrapperNotification
                    active={location.pathname.includes('/settings')}
                    className="wrapper"
                  >
                    <IconNotification
                      count={0}
                      icon={<SettingOutlineIcon height={18} width={18} />}
                    />
                  </WrapperNotification>
                </WrapperShortcut>
              </Tooltip>
            )}

            {!isCheckUI && (
              <Tooltip placement="bottom" title="Liên kết">
                <WrapperShortcut onClick={() => history.push(`/partner/request`)}>
                  <WrapperNotification
                    active={location.pathname.includes('/partner/request')}
                    className="wrapper"
                  >
                    <IconNotification
                      count={0}
                      icon={<InviteOutlineIcon height={18} width={18} />}
                    />
                  </WrapperNotification>
                </WrapperShortcut>
              </Tooltip>
            )}
            {!isCheckUI && (
              <Tooltip placement="bottom" title="Thông báo">
                <WrapperNotification
                  onClick={() => history.push(`/notification/overview/list`)}
                >
                  <IconNotification
                    count={notiCount}
                    icon={<BellOutlineIcon height={20} width={20} />}
                  />
                </WrapperNotification>
              </Tooltip>
            )}
            <Apps />
          </DivRow>
        )}
        <Dropdown
          arrow
          containerId="header"
          items={dropdownItems}
          menu={{ padding: '12px 0px', width: '280px' }}
        >
          <CRow styles={{ gap: 6, cursor: 'pointer' }} width="fit-content">
            <Avatar
              src={formatImageUrl(user?.avatar, IMAGETYPE.AVATAR.xxs)}
              styles={AvatarStyles}
            />
            {width > 1100 && (
              <CRow styles={{ gap: 6 }} width="fit-content">
                <Text textTransform="capitalize" weight="bold">
                  {getLastWord(user?.displayName || '') || 'Trống'}
                </Text>
                <CaretDownOutlined />
              </CRow>
            )}
          </CRow>
        </Dropdown>
      </DivRow>
    </Wrapper>
  );
};

export default HeaderMainNavbar;
